import { create } from 'zustand'
import { handleLocalStorage } from 'shared/helpers/handleLocalStorage'
import { IS_CC_SELECTED } from './types'

const GlobalStoreInit = {
  isCCSelected: false
}

const getInitialGlobalStore = () => {
  const isCCLS = handleLocalStorage(IS_CC_SELECTED)
  return {
    isCCSelected: isCCLS || GlobalStoreInit.isCCSelected
  }
}

export const useGlobalStore = create<IGlobalStore>(set => ({
  ...getInitialGlobalStore(),
  changeIsCCSelected: (newValue: boolean) => {
    handleLocalStorage({ IS_CC_SELECTED: newValue })
    set(state => {
      return {
        ...state,
        isCCSelected: newValue
      }
    })
  }
}))

export interface IGlobalStore {
  isCCSelected: boolean
  changeIsCCSelected: (value: boolean) => void
}
